import styles from '@components/ProductCardNew/ProductCardDescription/ProductDescription.styles';
import PriceArea from '@components/ProductCardNew/ProductCardDescription/PriceArea/PriceArea';
import SwatchesArea from '@components/ProductCardNew/ProductCardDescription/SwatchesArea/SwatchesArea';
import ProductCardDesriptionSkeleton from '@components/ProductCardNew/ProductCardDescription/ProductCardDescriptionSkeleton';
import { ISwatch } from '@typescript/index';
import { IGpsrObject } from '@features/categories/typescript';
type PropsType = {
  name: string;
  price: string;
  priceUnit: string | undefined;
  promoPrice: string;
  omnibusPrice: string;
  showFrom: boolean;
  swatches: ISwatch[];
  totalColorsCount?: number;
  isSmall?: boolean;
  searchHightlight?: JSX.Element;
  isLoading?: boolean;
  gpsr?: IGpsrObject | undefined;
};
const ProductCardDescription = ({
  name,
  price,
  priceUnit,
  promoPrice,
  omnibusPrice,
  showFrom,
  swatches,
  totalColorsCount,
  isSmall = false,
  searchHightlight = undefined,
  isLoading = false,
  gpsr = undefined
}: PropsType) => <div sx={styles.descriptionArea(isSmall)}>
    <span>{searchHightlight || name}</span>
    <PriceArea price={price} promoPrice={promoPrice} omnibusPrice={omnibusPrice} showFrom={showFrom} priceUnit={priceUnit} gpsr={gpsr} />
    <SwatchesArea swatches={swatches} totalColorsCount={totalColorsCount} />
    {isLoading && <ProductCardDesriptionSkeleton />}
  </div>;
export default ProductCardDescription;